import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgLock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "matrix(0.6666666666666666,0,0,0.6666666666666666,0,0)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-7.5,9a2,2,0,1,1,2-2A2,2,0,0,1,12,18.5ZM16.25,9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5V6.75a4.25,4.25,0,0,1,8.5,0Z"
		})
	})
});
export default SvgKgLock;
